import { render } from "./BagicEditor.vue?vue&type=template&id=eee631a4"
import script from "./BagicEditor.vue?vue&type=script&lang=js"
export * from "./BagicEditor.vue?vue&type=script&lang=js"

import "./BagicEditor.vue?vue&type=style&index=0&id=eee631a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__